// hooks/useEventDetailsState.js
import { useState } from "react";

export const useEventDetailsState = () => {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  return {
    event,
    setEvent,
    loading,
    setLoading,
    error,
    setError
  };
};